import React, { useState, useEffect } from "react";
import {
  Anchor,
  Card,
  Grid,
  Flex,
  Text,
  Box,
  UnstyledButton,
  ThemeIcon,
  Button,
  Badge,
} from "@mantine/core";
import { IconChevronDown, IconChevronUp, IconCheck } from "@tabler/icons-react";

import { EntitySms, EntityMessagingService } from "./";
import { Link } from "react-router-dom";

export default function EntityMessagingSms({
  title,
  context,
  reqData,
  fetchData,
  sms,
  messagingService,
  allowed,
  ready,
  active,
}) {
  const [createdPhoneId, setCreatedPhoneId] = useState(null);
  const [createdMessagingServiceId, setCreatedMessagingServiceId] =
    useState(null);
  const [smsVisible, setSmsVisible] = useState(false);
  const [messagingServiceVisible, setMessagingServiceVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  if (!reqData) return null;

  useEffect(() => {
    if (sms || messagingService) {
      setIsOpen(true);
    }

    if (messagingService) {
      setMessagingServiceVisible(true);
      setSmsVisible(false);
    }

    if (sms) {
      setSmsVisible(true);
      setMessagingServiceVisible(false);
    }

    if (!sms && !messagingService) {
      setSmsVisible(false);
      setMessagingServiceVisible(false);
    }
  }, [JSON.stringify(sms), JSON.stringify(messagingService)]);

  useEffect(() => {
    if (!sms) {
      setSmsVisible(false);
    }
    if (!messagingService) {
      setMessagingServiceVisible(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      if (createdPhoneId && !sms) {
        fetchData();
      }

      if (createdMessagingServiceId && !messagingService) {
        fetchData();
      }

      setCreatedPhoneId(null);
      setCreatedMessagingServiceId(null);
    }
  }, [isOpen]);

  const smsDisabled =
    messagingService || createdMessagingServiceId ? true : false;
  const messagingServiceDisabled = sms || createdPhoneId ? true : false;
  const isEffort = reqData?.campaign_effort_id ? true : false;
  // const showSms = isEffort ? !smsDisabled : true;
  const showSms = !smsDisabled && smsVisible;
  // const showMessagingService = isEffort ? !messagingServiceDisabled : true;
  const showMessagingService =
    !messagingServiceDisabled && messagingServiceVisible;
  const isLocation = reqData?.location_id ? true : false;
  const isOrg = reqData?.organization_id ? true : false;

  const isEnabled = sms || messagingService ? true : false;
  const createAllowed = isEffort ? false : true;

  const wrapperProps = {
    title,
    enabled: isEnabled,
    setIsOpen,
    isOpen,
    active,
  };

  // if (!allowed)
  //   return (
  //     <Wrapper {...wrapperProps}>
  //       <Grid.Col span={{ base: 12, md: 6 }}>
  //         <Card>
  //           <Text size="sm" fw={600} c="red">
  //             Not available at this time.
  //           </Text>
  //         </Card>
  //       </Grid.Col>
  //     </Wrapper>
  //   );

  if (!isEnabled && !createAllowed)
    return (
      <Wrapper {...wrapperProps}>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Card>
            <Text size="sm">
              Waiting for activation from{" "}
              <b>{reqData.organization_name || reqData.location_name}</b>.{" "}
              <Anchor
                component={Link}
                fw={600}
                to={
                  isOrg
                    ? `/organizations/${reqData.organization_id}/sms-messaging`
                    : `/locations/${reqData.location_id}/sms-messaging`
                }
              >
                Manage activation here.
              </Anchor>
            </Text>
          </Card>
        </Grid.Col>
      </Wrapper>
    );

  if (!smsVisible && !messagingServiceVisible)
    return (
      <Wrapper {...wrapperProps}>
        <Grid.Col span={{ base: 12, md: 3 }}>
          <Card p="xs">
            {(context === "transactional_sms" && !allowed) ||
            (context === "sms_marketing" && !allowed) ? (
              <Text size="sm" fw={600} c="red">
                Not available at this time.
              </Text>
            ) : (
              <Flex gap="xs">
                <Button
                  onClick={() => {
                    setSmsVisible(true);
                    setIsOpen(true);
                  }}
                  fullWidth
                  variant="gradient"
                >
                  Enable SMS
                </Button>
              </Flex>
            )}
          </Card>
        </Grid.Col>
        {context !== "transactional_sms" && allowed && (
          <Grid.Col span={{ base: 12, md: 3 }}>
            <Card p="xs">
              <Flex gap="xs">
                <Button
                  onClick={() => {
                    setMessagingServiceVisible(true);
                    setIsOpen(true);
                  }}
                  fullWidth
                  variant="gradient"
                >
                  Enable Messaging Service
                </Button>
              </Flex>
            </Card>
          </Grid.Col>
        )}
      </Wrapper>
    );

  return (
    <div>
      <Wrapper {...wrapperProps}>
        {showSms && (
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card>
              {smsDisabled ? (
                <NotAllowed
                  enabledText="Messaging Service"
                  disabledText="SMS"
                />
              ) : (
                <EntitySms
                  allowed={allowed}
                  ready={ready}
                  active={active}
                  reqData={{
                    ...reqData,
                    context,
                  }}
                  fetchData={fetchData}
                  info={sms}
                  setCreatedId={setCreatedPhoneId}
                />
              )}
            </Card>
          </Grid.Col>
        )}
        {showMessagingService && (
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Card>
              {messagingServiceDisabled ? (
                <NotAllowed
                  enabledText="SMS"
                  disabledText="Messaging Service"
                />
              ) : (
                <>
                  <EntityMessagingService
                    allowed={allowed}
                    ready={ready}
                    active={active}
                    reqData={{
                      ...reqData,
                      context,
                    }}
                    fetchData={fetchData}
                    messagingService={messagingService}
                    setCreatedId={setCreatedMessagingServiceId}
                  />
                </>
              )}
            </Card>
          </Grid.Col>
        )}
      </Wrapper>
      {!sms &&
        !messagingService &&
        !createdPhoneId &&
        !createdMessagingServiceId && (
          <Button
            variant="subtle"
            color="gray"
            size="xs"
            mb="lg"
            onClick={() => {
              setSmsVisible(false);
              setMessagingServiceVisible(false);
            }}
          >
            Start over
          </Button>
        )}
    </div>
  );
}

const NotAllowed = ({ enabledText, disabledText }) => {
  return (
    <Box mih={150} p="lg" ta="center">
      <Flex justify="center" align="center" h={150}>
        <Text w={"80%"}>
          Not allowed while {enabledText} is enabled. Release {enabledText}{" "}
          before enabling {disabledText}.
        </Text>
      </Flex>
    </Box>
  );
};

const Wrapper = ({ children, title, enabled, setIsOpen, isOpen, active }) => {
  return (
    <Box mb="lg">
      <UnstyledButton onClick={() => setIsOpen(!isOpen)}>
        <Flex mb="xs" align="center" gap="xs">
          {enabled && (
            <ThemeIcon size="xs" radius="xl" color="green">
              <IconCheck size={16} />
            </ThemeIcon>
          )}
          <Text fw={600}>{title}</Text>
          {active && (
            <Badge size="xs" color="green" variant="light">
              Active
            </Badge>
          )}
          {isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
        </Flex>
      </UnstyledButton>
      {isOpen && <Grid>{children}</Grid>}
    </Box>
  );
};
